import { useMutation } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { combinedModelApi } from "../api/combinedModel.api";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { useTranslation } from "react-i18next";

const useCombineModelValues = () => {
  const { t } = useTranslation();
  const [bearerToken, toast] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken, state.toastRef]),
  );

  const getCombinedValues = async (companyId: string, modelId: string) => {
    return await getCombinedValuesMutation.mutateAsync({
      companyId,
      modelId,
    });
  };

  const getCombinedValuesMutation = useMutation({
    mutationFn: (payload: { companyId: string; modelId: string }) =>
      combinedModelApi.getCombinedByModel(bearerToken as string, payload),
    onSuccess: (data) => {
      // Handle success, e.g., update state or notify user
    },
    onError: (error) => {
      // 404 just means the current model has no materials, not a real error
      if (isAxiosError(error) && error.response?.status === 404) {
        return;
      }
      toast?.current?.show({
        severity: "error",
        detail: t("combine-error"),
      });
    },
  });

  return {
    error: getCombinedValuesMutation.error,
    isPending: getCombinedValuesMutation.isPending,
    getCombinedValues,
  };
};

export default useCombineModelValues;
